import styled from "styled-components";
import React, { useCallback, useContext, useEffect, useState } from "react";

export const ProfileRow = ({ avatarColor, statusColors, onClick, index, profile, selected }) => {
  // extract initials from userFname and userLname
  const initials = profile.profiledata.userFname.charAt(0) + profile.profiledata.userLname.charAt(0);

  return (
    <RowContainer selected={selected} onClick={onClick} className="RowContainer">
      <Index className="Index">{(index + 1)}</Index>
      <Avatar $color={avatarColor} className="Avatar">{initials}</Avatar>
      <HighlightRow className="HighlightRow">
        <CompanyName className="CompanyName">{profile.profiledata.orgName}</CompanyName>
        <Location className="Location">
          {profile.profiledata.userLocation} <span role="img" aria-label="Building"></span>
        </Location>
        <Website className="Website"><span url={profile.profiledata.profileUrl}>{profile.profiledata.profileUrl}</span></Website>
      </HighlightRow>
      <Status className="Status">
        <div className="status-dot" style={{ backgroundColor: statusColors[profile?.status?.toLowerCase()] }}></div>
        {profile?.status}
      </Status>
    </RowContainer>
  );
};


const RowContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 0px 5px;
  font-size: 12px;
  gap: 10px;

  &:nth-child(n+10) {
    margin-left: -6px;
  }

  &:hover {
    cursor: default;
    .Index {
      color: black;
    }
    .HighlightRow {
      background: #f1f1f1;
      transition: background 0.2s ease-in-out;
    }
    .Location {
      background: white;
      transition: background 0.2s ease-in-out;
      font-weight: 700;
      cursor: default;
    }
    .Status {
      background: #f1f1f1;
      color: black;
      cursor: pointer;
    }
    .CompanyName {
      font-weight: 700;
      cursor: default;
    }
    .Website {
      cursor: default;
    }
  }

  ${props => props.selected && `
    .HighlightRow {
      background: black;
      color: white;
      font-weight: 700;
      .Location {
        color: black;
      }
      .Website {
        color: white;
      }
    }
    &:hover {
      .HighlightRow {
        background: black;
        color: white;
        .Location {
          color: black;
        }
        .Website {
          color: white;
        }
      }
    }
  `}
`;

const Index = styled.div`
  color: #A8A8A8;
  font-family: "PT Sans";
  font-size: 11px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 0.12px;
  margin: 0px 8px 0px 5px;
`;

export const Avatar = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  box-sizing: border-box;
  background-color: #C6F6D5;
  background-color: #${props => props.$color};
  border-radius: 100%;
  font-weight: bold;
  color: #333;
  font-size: 11px;
  width: 30px;
  height: 30px;
`;

const HighlightRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  padding: 5px 10px 5px 12px;
  box-sizing: border-box;
  border-radius: 3px;
  flex: 1;
  min-width: 0;
  width: 100%;
  justify-content: space-between;
`;

const CompanyName = styled.div`
  cursor: default;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 2;
  min-width: 120px;
  flex-shrink: 0;
`;

const Location = styled.div`
  cursor: default;
  display: flex;
  padding: 2px 10px;
  background-color: #f1f1f1;
  border-radius: 2px;
  font-size: 12px;
  flex: 1;
  min-width: 80px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-shrink: 0;
  span {
    margin-left: 4px;
  }
`;

const Website = styled.div`
  cursor: default;
  text-decoration: underline;
  color: #8C8C8C;
  letter-spacing: 0.12px;
  text-underline-offset: 2px;
  min-width: 100px;
  flex: 2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-shrink: 0;

  &:hover {
    color: black;
  }
`;

const Status = styled.div`
  color: #000;
  font-family: "PT Sans";
  font-size: 11px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 0.1px;
  display: flex;
  gap: 15px;
  flex: .25;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  align-items: center;
  height: 30px;
  padding: 20px 10px 20px 30px;
  border-radius: 4px;
  box-sizing: border-box;
  text-transform: capitalize;
  .status-dot {
    width: 9px;
    height: 9px;
    border-radius: 50%;
  }

  .Caret {
    color: black;
    margin-left: auto;
  }

  &:hover {
    background: black !important;
    color: white !important;
    .Caret {
      display: block;
      color: white;
    }
  }
`;
